const state = {
    role: '',
    content: {},
    author: {},
    publisher: {},
    publication: {},
    userRights: {},
    type: '',
    openDialogBox: false,
    tableData: [],
    showTableSettings: false,
    container: false,
    isAddPublisher: false,
    hideSearchOnTop: false,
    tableFilters: {},
    clearFilters: false,
    callPublishers: {}
};

const getters = {
    getUserRole (state) {
        return state.role
    },
    getContent (state) {
        return state.content
    },
    getAuthor (state) {
        return state.author
    },
    getPublication (state) {
        return state.publication
    },
    getPublisher (state) {
        return state.publisher
    },
    getUserRights (state) {
        return state.userRights
    },
    getType (state) {
        return state.type
    },
    getDialog (state) {
        return state.openDialogBox
    },
    getTableData (state) {
        return state.tableData
    },
    getShowTableSettings (state) {
        return state.showTableSettings
    },
    getContainer (state) {
        return state.container
    },
    getAddPublisher (state) {
        return state.isAddPublisher
    },
    getHideSearchOnTop (state) {
        return state.hideSearchOnTop
    },
    getTableFilters (state) {
        return state.tableFilters
    },
    getClearFilters (state) {
        return state.clearFilters
    },
    getCallPublishers (state) {
        return state.callPublishers
    }
};

const mutations = {
    SET_USER_ROLE (state, payload) {
        state.role = payload
    },
    SET_CONTENT (state, payload) {
        state.content = payload
    },
    UNSET_CONTENT (state) {
        state.content = {}
    },
    SET_PUBLISHER (state, payload) {
        state.publisher = payload
    },
    SET_PUBLICATION (state, payload) {
        state.publication = payload
    },
    SET_AUTHOR (state, payload) {
        state.author = payload
    },
    SET_USER_RIGHTS (state, payload) {
        state.userRights = payload
    },
    SET_TYPE (state, payload) {
        state.type = payload
    },
    SET_DIALOG (state, payload) {
        state.openDialogBox = payload
    },
    SET_TABLE_DATA (state, payload) {
        state.tableData = payload
    },
    SET_SHOW_TABLE_SETTINGS (state, payload) {
        state.showTableSettings = payload
    },
    SET_CONATINER (state, payload) {
        state.container = payload
    },
    SET_IS_ADD_PUBLISHER (state, payload) {
        state.isAddPublisher = payload
    },
    SET_HIDE_SEARCH_ON_TOP (state, payload) {
        state.hideSearchOnTop = payload
    },
    SET_TABLE_FILTERS (state, payload) {
        state.tableFilters = payload
    },
    SET_CLEAR_FILTERS (state, payload) {
        state.clearFilters = payload
    },
    SET_CALL_PUBLISHERS (state, payload) {
        state.callPublishers = payload
    }
};

const actions = {
    setUserRole ({commit}, payload) {
        commit('SET_USER_ROLE', payload)
    },
    setContent ({commit}, payload) {
        commit('SET_CONTENT', payload)
    },
    unsetContent ({commit}) {
        commit('UNSET_CONTENT')
    },
    set_author ({commit}, payload) {
        commit('SET_AUTHOR', payload)
    },
    set_publisher ({commit}, payload) {
        commit('SET_PUBLISHER', payload)
    },
    set_publication ({commit}, payload) {
        commit('SET_PUBLICATION', payload)
    },
    setUserRights ({commit}, payload) {
        commit('SET_USER_RIGHTS',payload)
    },
    setType ({commit}, payload) {
        commit('SET_TYPE', payload)
    },
    setDialog ({commit}, payload) {
        commit('SET_DIALOG', payload)
    },
    setTableData ({commit}, payload) {
        commit ('SET_TABLE_DATA', payload)
    },
    setShowTableSettings ({commit}, payload) {
        commit ('SET_SHOW_TABLE_SETTINGS', payload)
    },
    setContainer ({commit}, payload) {
        commit('SET_CONATINER', payload)
    },
    setAddPublisher ({commit}, payload) {
        commit('SET_IS_ADD_PUBLISHER', payload)
    },
    setHideSearchOnTop ({commit}, payload) {
        commit('SET_HIDE_SEARCH_ON_TOP', payload)
    },
    setTableFilters ({commit}, payload) {
        commit('SET_TABLE_FILTERS', payload)
    },
    setClearFilters ({commit}, payload) {
        commit('SET_CLEAR_FILTERS', payload)
    },
    setCallPublishers ({commit}, payload) {
        commit('SET_CALL_PUBLISHERS', payload)
    }
};

export default {
    state,
    mutations,
    actions,
    getters
  }